export default __webpack_public_path__ + "static/media/gw200-2.382dccb9.png";